// extracted by mini-css-extract-plugin
export default {"container":"style_container__uFRKM","divider":"style_divider__kwe0s","qrCode":"style_qrCode__IU1qV"};